import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationFamilyCar: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={356}
        height={228}
      >
        <path d="M0 0h356v228H0V0Z" fill="#C0C2C9" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160Z"
          fill={colors.primary[50]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 226a2 2 0 0 1 2-2h310a2 2 0 1 1 0 4H22a2 2 0 0 1-2-2Z"
          fill={colors.primary[500]}
        />
        <path
          d="M8 186.5c0 14.5 11 21 21 21h11.5L66 202h215.5c19 0 35.5 3.5 50 0 11.6-2.8 13.167-9.5 12.5-12.5V138c0-10.4-4.667-15.667-7-17l-37.5-33.5h-103c-28.5 0-30 0-57 18s-41 23.5-51 26S50 140 29 144.5C8 151 8 172 8 186.5Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168.026 91.662c-6.978 2.147-13.847 6.456-27.417 15.502-27.104 18.07-41.32 23.7-51.624 26.276-8.205 2.051-28.765 6.439-47.448 10.426-4.155.887-8.217 1.754-12.03 2.571-9.726 3.038-14.535 9.346-16.985 16.695C10.017 170.648 10 179.191 10 186.5c0 6.694 2.515 11.38 6.053 14.421C19.64 204.002 24.407 205.5 29 205.5h11.287l25.5-5.5H281.5c6.686 0 13.112.432 19.172.839 2.611.176 5.154.346 7.621.476 8.276.436 15.784.419 22.738-1.259 5.469-1.32 8.296-3.489 9.706-5.413 1.425-1.945 1.516-3.784 1.311-4.709l-.048-.214V138c0-9.82-4.393-14.35-5.992-15.264l-.183-.104L298.737 89.5H196.5c-14.356 0-21.512.02-28.474 2.162Zm28.13-6.162h104.107l37.926 33.88c3.077 1.892 7.811 7.872 7.811 18.62v51.3c.385 2.063-.023 4.958-2.037 7.707-2.107 2.876-5.863 5.457-11.994 6.937-7.546 1.822-15.538 1.805-23.887 1.366-2.58-.136-5.187-.311-7.833-.489-6.001-.404-12.202-.821-18.749-.821H66.213l-25.5 5.5H29c-5.406 0-11.14-1.752-15.553-5.546C8.985 200.12 6 194.306 6 186.5v-.134c0-7.171 0-16.315 2.728-24.498 2.793-8.379 8.464-15.807 19.68-19.279l.086-.026.087-.019c3.86-.827 7.97-1.704 12.17-2.6 18.682-3.987 39.135-8.352 47.264-10.384 9.695-2.424 23.48-7.794 50.376-25.724 13.43-8.954 20.811-13.645 28.458-15.998 7.601-2.338 15.38-2.338 29.307-2.338Z"
          fill={colors.primary[500]}
        />
        <path
          d="M29 187v20.5h18.5l18-6H103V187c0-16-19-26-27-26H59.5C40.3 161 29 176 29 187Z"
          fill={colors.primary[200]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.5 163C41.368 163 31 177.141 31 187v18.5h16.175l18-6H101V187c0-7.154-4.25-13.134-9.733-17.425a36.037 36.037 0 0 0-8.43-4.911C80.064 163.531 77.645 163 76 163H59.5ZM27 187c0-12.141 12.232-28 32.5-28H76c2.355 0 5.311.719 8.35 1.961a40.049 40.049 0 0 1 9.383 5.464C99.75 171.134 105 178.154 105 187v16.5H65.825l-18 6H27V187Z"
          fill={colors.primary[500]}
        />
        <path
          d="M96 199c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.569 0 30 13.431 30 30Z"
          fill={colors.primary[100]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66 225c14.36 0 26-11.641 26-26s-11.64-26-26-26-26 11.641-26 26 11.64 26 26 26Zm0 4c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30Z"
          fill={colors.primary[500]}
        />
        <path
          d="M83 199c0 9.389-7.611 17-17 17s-17-7.611-17-17 7.611-17 17-17 17 7.611 17 17Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66 212c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13Zm0 4c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17Z"
          fill={colors.primary[500]}
        />
        <path
          d="M318 187v16.5h-18.5l-18-2H244V187c0-16 19-26 27-26h16.5c19.2 0 30.5 15 30.5 26Z"
          fill={colors.primary[200]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M287.5 163c18.132 0 28.5 14.141 28.5 24v14.5h-16.389l-18-2H246V187c0-7.154 4.25-13.134 9.733-17.425a36.02 36.02 0 0 1 8.43-4.911c2.773-1.133 5.191-1.664 6.837-1.664h16.5Zm32.5 24c0-12.141-12.232-28-32.5-28H271c-2.354 0-5.311.719-8.35 1.961a40.058 40.058 0 0 0-9.383 5.464C247.25 171.134 242 178.154 242 187v16.5h39.389l18 2H320V187Z"
          fill={colors.primary[500]}
        />
        <path
          d="M311 199c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.569 0 30 13.431 30 30Z"
          fill={colors.primary[100]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M281 225c14.359 0 26-11.641 26-26s-11.641-26-26-26-26 11.641-26 26 11.641 26 26 26Zm0 4c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30Z"
          fill={colors.primary[500]}
        />
        <path
          d="M298 199c0 9.389-7.611 17-17 17s-17-7.611-17-17 7.611-17 17-17 17 7.611 17 17Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M281 212c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13Zm0 4c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17Z"
          fill={colors.primary[500]}
        />
        <path
          d="M136 133.5h170.5c14.5 0 10.4-11.6 6-16-5.5-5.5-11.5-11-17-16-4.4-4-12.833-5-16.5-5h-92c-12.4 0-18.833 2.667-20.5 4C156.333 107 135 120.6 131 123c-5 3-4.5 10.5 5 10.5Z"
          fill={colors.primary[200]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M173.206 99.941c-3.259.807-4.956 1.72-5.457 2.121l-.082.066-.09.057c-10.147 6.488-31.516 20.111-35.548 22.53-1.884 1.13-2.419 2.882-2.054 4.076.328 1.072 1.743 2.709 6.025 2.709h170.5c3.396 0 5.381-.685 6.495-1.497 1.043-.76 1.513-1.768 1.597-2.99.089-1.291-.265-2.814-.955-4.328-.684-1.505-1.633-2.852-2.551-3.771-5.463-5.463-11.431-10.934-16.931-15.934-1.834-1.667-4.658-2.816-7.648-3.535-2.951-.71-5.818-.945-7.507-.945h-92c-6.059 0-10.604.652-13.794 1.441Zm-.962-3.882c3.544-.877 8.415-1.559 14.756-1.559h92c1.977 0 5.16.266 8.443 1.055 3.243.781 6.836 2.132 9.402 4.465 5.5 5 11.532 10.529 17.069 16.066 1.282 1.281 2.496 3.034 3.364 4.942.864 1.898 1.453 4.1 1.305 6.259-.154 2.228-1.102 4.395-3.231 5.948-2.058 1.5-4.998 2.265-8.852 2.265H136c-5.218 0-8.803-2.113-9.85-5.541-1.011-3.306.705-6.804 3.821-8.674 3.958-2.375 25.155-15.887 35.372-22.42 1.195-.915 3.516-1.968 6.901-2.806Z"
          fill={colors.primary[500]}
        />
        <path d="M204 97h11l-9 36h-11l9-36Z" fill="#fff" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M202.438 95h15.124l-10 40h-15.124l10-40Zm3.124 4-8 32h6.876l8-32h-6.876Z"
          fill={colors.primary[500]}
        />
        <path d="M260 97h11l18 36h-11l-18-36Z" fill="#fff" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M256.764 95h15.472l20 40h-15.472l-20-40Zm6.472 4 16 32h6.528l-16-32h-6.528Z"
          fill={colors.primary[500]}
        />
        <path
          d="M26 165.5c-3.313 2.65-9 2.5-16.5 2.5 0-5.6 4.333-11.333 6.5-13.5h13.5c5.2 0 5.5 3.5 3.5 5s-4.5 4-7 6Z"
          fill={colors.primary[100]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.172 152.5H29.5c2.953 0 5.332 1.011 6.276 3.121.93 2.081.015 4.285-1.576 5.479-.918.688-1.976 1.627-3.179 2.703l-.19.17c-1.123 1.006-2.35 2.103-3.582 3.089-2.103 1.682-4.813 2.363-7.718 2.671-2.601.275-5.624.272-8.876.268L9.5 170h-2v-2c0-3.283 1.257-6.466 2.695-9.019 1.448-2.571 3.186-4.69 4.39-5.895l.587-.586Zm1.688 4a25.663 25.663 0 0 0-3.18 4.444c-.91 1.617-1.636 3.351-1.974 5.057 2.845 0 5.29-.022 7.404-.246 2.641-.28 4.431-.849 5.64-1.817 1.144-.914 2.294-1.943 3.439-2.968l.165-.148c1.172-1.049 2.364-2.11 3.446-2.922.409-.306.344-.602.324-.646-.006-.015-.377-.754-2.624-.754H16.86Z"
          fill={colors.primary[500]}
        />
        <path
          d="M337 133.5h6.5v23H330c-3.2 0-3.333-2.667-3-4 1.5-4.167 4.8-13.1 6-15.5 1.2-2.4 3.167-3.333 4-3.5Z"
          fill={colors.primary[100]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M336.608 131.539c.129-.026.26-.039.392-.039h6.5a2 2 0 0 1 2 2v23a2 2 0 0 1-2 2H330c-1.078 0-2.056-.226-2.885-.717a4.393 4.393 0 0 1-1.75-1.932c-.655-1.394-.538-2.906-.305-3.836.016-.065.036-.129.058-.192 1.477-4.103 4.826-13.183 6.093-15.717 1.494-2.987 3.998-4.287 5.397-4.567Zm.652 3.961c-.451.159-1.667.786-2.471 2.394-1.123 2.246-4.327 10.899-5.867 15.171-.031.155-.052.35-.045.551.009.24.054.419.108.533a.4.4 0 0 0 .169.193c.086.051.324.158.846.158h11.5v-19h-4.24Z"
          fill={colors.primary[500]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M343.5 144.5h-13v-4h13v4Z"
          fill={colors.primary[500]}
        />
      </g>
    </svg>
  );
};

export default IllustrationFamilyCar;
